import { shallowRef, type ShallowRef } from "vue";

export type SportsConfigurationSaveFn = () => Promise<void>;

export const sportsConfigurationSaveRef: ShallowRef<SportsConfigurationSaveFn | null> =
  shallowRef(null);
